import moment from 'moment';

import { Event } from '~/repositories/calendar/store/calendar.models';

export const dateIsHoliday = (
  { day, month, year }: { day: number; month: number; year: number },
  holidays: string[]
) => {
  const parsedDate = moment(new Date()).set({ date: day, month, year }).format('DD/MM/yyyy');
  return holidays.includes(parsedDate);
};

export const dateHasEvents = ({ day, month, year }: { day: number; month: number; year: number }, events: Event[]) => {
  const parsedDate = moment(new Date()).set({ date: day, month, year });
  return events.some((event) => parsedDate.isSame(moment(event.start), 'day'));
};

export const addHoursUntilMaxEndOfDay = (date: Date, hours: number) => {
  const newTime = moment(date).add(hours, 'hours').subtract(1, 'second');
  const endOfDay = moment(date).endOf('day').subtract(1, 'second');

  if (newTime.isAfter(endOfDay)) {
    return endOfDay.toDate();
  }
  return newTime.toDate();
};
